import React, { useEffect } from "react";

const Timer = ({ secondsRemaining, setSecondsRemaining }) => {
  useEffect(() => {
    let intervalId;
    if (secondsRemaining > 0) {
      intervalId = setInterval(() => {
        setSecondsRemaining((prevSeconds) => Math.max(prevSeconds - 1, 0));
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [secondsRemaining]); // Dependency array ensures effect runs only on seconds change

  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;

  return (
    <div className="btn-start">
      {minutes.toString().padStart(2, "0")}:
      {seconds.toString().padStart(2, "0")}
    </div>
  );
};

export default Timer;
